import Axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { isObject } from "lodash";

export function createAxiosInstance(): AxiosInstance {
  return Axios.create({ baseURL: "/api", withCredentials: true });
}

export const getResponseFilename = (response: AxiosResponse): string => {
  const headerLine = response.headers["content-disposition"];
  if (headerLine.includes('"')) {
    return headerLine.substring(headerLine.indexOf('"') + 1, headerLine.lastIndexOf('"'));
  } else {
    return headerLine;
  }
};

export const downloadFile = (
  file: Blob | { url: string } | { data: Blob | ArrayBuffer },
  filename?: string,
) => {
  const downloadFileName = filename && filename.length > 0 ? filename : "file.pdf";
  const url =
    file instanceof Blob
      ? window.URL.createObjectURL(file)
      : "data" in file
        ? window.URL.createObjectURL(new Blob([file.data]))
        : file.url;
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", downloadFileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
};

export const getFilenameFromHeaders = (headers?: Record<string, unknown>): string | undefined => {
  const h = headers?.["content-disposition"];
  if (h) {
    const match = /filename="([^"]*)"/.exec(String(h));
    if (match) {
      return decodeURIComponent(match[1].replace(/\+/g, "%20"));
    }
  }
};

export enum HttpStatus {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  CONFLICT = 409,
  NOT_FOUND = 404,
  LOCKED = 423,
  TOO_MANY_REQUESTS = 429,
}

export function isHttpError(status: HttpStatus, error: unknown): error is AxiosError {
  return isAxiosError(error) && error.response?.status === status;
}

export function isNetworkError(error: unknown): error is AxiosError {
  return isAxiosError(error) && error.code === AxiosError.ERR_NETWORK;
}

export function isAxiosError(error: unknown): error is AxiosError {
  return isObject(error) && "isAxiosError" in error;
}

export function isBadRequestError(error: unknown): error is AxiosError {
  return isHttpError(HttpStatus.BAD_REQUEST, error);
}
